import React from "react";
import { CloudDone } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { UploadICON } from "../assets/icons";
import i18n from "../i18n-config";

interface Props {
  title?: string | null;
  showAvatar?: boolean;
  getRootProps?: any;
  getInputProps?: any;
  acceptedFiles?: any;
  containerStyle?: React.CSSProperties;
}

export default function CustomDropzone({
  title = i18n.t("uploader_photos"),
  showAvatar = true,
  getRootProps,
  getInputProps,
  acceptedFiles,
  containerStyle
}: Props) {
  return (
    <div {...getRootProps}>
      <Box
        sx={{
          borderRadius: "5px",
          border: "1px dashed #00833D",
          height: 174,
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          ...containerStyle
        }}
      >
        {!acceptedFiles?.length ? (
          <Box>
            <Typography style={{ textAlign: "center" }}>
              <UploadICON />
            </Typography>

              <Typography>{title}</Typography>
          </Box>
        ) : (
          <Stack alignItems="center">
            <Stack alignItems="center" spacing={1}>
              <Stack
                spacing={3}
                sx={{
                  width: 60,
                  height: 60,
                  backgroundColor: "white",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 2,
                }}
              >
                <CloudDone fontSize="large" />
              </Stack>
              <div>
                <Typography fontSize={18} color="#5D5C5C">
                  {acceptedFiles[0]?.path}
                </Typography>
                {/* <Typography color="#909293">
                  {acceptedFiles[0]?.size} bytes
                </Typography> */}
              </div>
            </Stack>
            <Typography
              mt={2}
              color="#dd3d45"
              sx={{ textDecoration: "underline" }}
            >
              Remplacer
            </Typography>
          </Stack>
        )}
      </Box>
      <input
        {...getInputProps}
        style={{ borderStyle: "none", display: "none" }}
      />
    </div>
  );
}
